import { render, staticRenderFns } from "./PagedListInterests.vue?vue&type=template&id=0473045b&"
import script from "./PagedListInterests.vue?vue&type=script&lang=js&"
export * from "./PagedListInterests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports